import { FunctionComponent } from "react";

import { colours } from "@/utils";
import CtaStrip from "../../CtaStrip";
import CoursesForAllSection from "./CoursesForAllContent";
import AllBrightAcademyContent from "./AllBrightAcademyContent";
import QuoteContent from "../../QuoteContent";
import CourseLineupContent from "./CourseLineupContent";
import { Course } from "@/types/learning/Course";

const quote = {
  author: "Learner Testimonial",
  hrefOne: "/memberships",
  linkTextOne: "Become a Learner",
  paragraphs: [
    "“I was surprised, how much I was able to soak up and how many tools I have learnt that will help me to reflect on my career path and what steps I need to take.”",
  ],
  source: "AllBright Academy",
  background: colours.marketingYellow,
};

type MainCoursesContentProps = {
  courses: Course[];
};

const MainCoursesContent: FunctionComponent<MainCoursesContentProps> = (
  props
) => {
  return (
    <>
      <CoursesForAllSection />
      <AllBrightAcademyContent />
      <QuoteContent {...quote} />
      <CtaStrip
        copy="Ready to begin?"
        linkText="Become a Learner"
        linkUrl={"/memberships"}
        backgroundColour={colours.marketingBlue}
        textColour={colours.shell}
      />
      <CourseLineupContent {...props} />
    </>
  );
};

export default MainCoursesContent;
